<template>
  <div class="message" :class="dynamicClasses">
    <p class="message-text">{{ $t("login.session_expired") }}</p>
  </div>
</template>

<script>
  // vuex
  import {mapGetters} from "vuex";

  export default {
    name: 'ErrorMessage',
    computed: {
      ...mapGetters(['messageShow']),
      dynamicClasses() {
        const classes = [];

        if (this.messageShow) {
          classes.push('d-block');
        } else {
          classes.push('d-none');
        }
        return classes
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "src/assets/scss/variables";

  .message {
    position: absolute;
    bottom: $gm-bottom-offset;
    padding: $gm-wrapper-padding;
    left: 50%;
    transform: translatex(-50%);
    background-color: $gm-bg-color;
    border-radius: $gm-border-radius;
    text-align: center;
    z-index: $gm-z-index;

    &-text {
      font-size: $gm-font-size;
      color: $gm-color;
      margin: 0;
      padding: 0;
    }
  }
</style>